import { FC } from "react";
import { Field, FieldRenderProps } from "react-final-form";

import { FormField, Input, SpacingToken } from "@livechat/design-system-react-components";

import { Divider } from "components/divider/Divider";
import Flex from "components/layout/Flex";
import { FormBlockType, IFormBlockSubject } from "store/entities/contact-forms/interfaces";
import { withVar } from "themes/helpers";

import { RequiredErrorField } from "./parts/RequiredErrorField";

interface IProps {
  name: string;
  blockType: FormBlockType;
}

export const SubjectBlock: FC<IProps> = ({ name, blockType }) => {
  return (
    <Field name={name}>
      {({ input, meta }) => <SubjectBlockInput input={input} meta={meta} blockType={blockType} />}
    </Field>
  );
};

const SubjectBlockInput: FC<FieldRenderProps<IFormBlockSubject>> = ({ input, blockType }) => {
  return (
    <Flex column>
      <Field name={`${input.name}.value`}>
        {({ input, meta }) => (
          <FormField
            labelText="Subject label"
            error={meta.error}
            css={{
              marginBottom: withVar(SpacingToken.Spacing4),
            }}
          >
            <Input {...input} error={meta.error} data-testid="subject-input-label" />
          </FormField>
        )}
      </Field>
      {input.value.required && (
        <>
          <Divider />
          <Field<IFormBlockSubject["requiredError"]>
            name={`${input.name}.requiredError`}
            render={RequiredErrorField}
            blockType={blockType}
          />
        </>
      )}
    </Flex>
  );
};
